export default {
  blackCoral: {
    "50": "#f9fafb",
    "100": "#f0f1f3",
    "200": "#d9dbdf",
    "300": "#b7bbc2",
    "400": "#8f959f",
    "500": "#6e7582",
    "600": "#555e6e",
    "700": "#3e4859",
    "800": "#283242",
    "900": "#131f30",
    "950": "#131f31",
  },
  jasper: {
    "50": "#fff6f6",
    "100": "#ffefef",
    "200": "#f9d3d3",
    "300": "#eaa6a6",
    "400": "#e56d6d",
    "500": "#d93c3e",
    "600": "#bd0e0f",
    "700": "#930705",
    "800": "#680605",
    "900": "#470201",
    "950": "#470202",
  },
  sapGreen: {
    "50": "#f8f8f3",
    "100": "#f2f0d0",
    "200": "#e0e29c",
    "300": "#b8c266",
    "400": "#7c9d3a",
    "500": "#5b7f1e",
    "600": "#496714",
    "700": "#3a4d12",
    "800": "#28350f",
    "900": "#1b200c",
    "950": "#1b2001",
  },
  grass: {
    "50": "#f5f7f4",
    "100": "#e8f0e2",
    "200": "#cae4be",
    "300": "#96c78a",
    "400": "#51a459",
    "500": "#398834",
    "600": "#2e7024",
    "700": "#27551f",
    "800": "#1c3a19",
    "900": "#132313",
    "950": "#132314",
  },
  ochre: {
    "50": "#fcfbf8",
    "100": "#f9f0dc",
    "200": "#f3d8b7",
    "300": "#e2b084",
    "400": "#d08455",
    "500": "#b86134",
    "600": "#9a4722",
    "700": "#76351b",
    "800": "#512414",
    "900": "#33160d",
    "950": "#34160d",
  },
  cerise: {
    "50": "#fff5fb",
    "100": "#fdeaf5",
    "200": "#fbd2e9",
    "300": "#e9a7cc",
    "400": "#de6ea8",
    "500": "#d53485",
    "600": "#b90263",
    "700": "#90084c",
    "800": "#5e1734",
    "900": "#301820",
    "950": "#321921",
  },
  navy: {
    "50": "#f4f8f8",
    "100": "#e1f0f6",
    "200": "#bbe2eb",
    "300": "#88c3d1",
    "400": "#4da0af",
    "500": "#38808f",
    "600": "#2f6672",
    "700": "#274d58",
    "800": "#1c343f",
    "900": "#11202a",
    "950": "#111f29",
  },
  vistaBlue: {
    "50": "#f5f8ff",
    "100": "#e5edff",
    "200": "#ccdafc",
    "300": "#a5b8e9",
    "400": "#7c91e1",
    "500": "#5c69e9",
    "600": "#4a46e1",
    "700": "#3a31b9",
    "800": "#282284",
    "900": "#191452",
    "950": "#1a1552",
  },
  lavender: {
    "50": "#fafafb",
    "100": "#f0f0fa",
    "200": "#e0d5f6",
    "300": "#c4aee9",
    "400": "#ae83da",
    "500": "#965fcc",
    "600": "#7c43b5",
    "700": "#5d3290",
    "800": "#3f2264",
    "900": "#24163a",
    "950": "#24163b",
  },
} as const;
